import React from 'react';
const UserTypeContext = React.createContext('');
export const UserTypeProvider = UserTypeContext.Provider;
export default UserTypeContext;
